import { apiConfig } from 'config';
import { handle420 } from 'apis/HandleError';
import { fetchdata } from './FetchData';

export function getBundle(bundleId) {
  const url = apiConfig.bmServiceGetBundle(bundleId);

  return fetchdata(url, { method: 'GET' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}

export function createBundle(bundleObj) {
  let postBody = {
    ...(bundleObj.name && { name: bundleObj.name }),
    ...(bundleObj.type && { type: bundleObj.type }),
    ...(bundleObj.code && { code: bundleObj.code }),
    ...(bundleObj.members && { members: bundleObj.members }),
    ...(bundleObj.memberPosition && { memberPosition: bundleObj.memberPosition }),
    ...(bundleObj.description && { description: bundleObj.description }),
    ...(bundleObj.repeaterLocation && { repeaterLocation: bundleObj.repeaterLocation }),
    ...(bundleObj.address && { address: bundleObj.address }),
    ...(bundleObj.configurationParameters && { configurationParameters: bundleObj.configurationParameters })
  };

  return fetchdata(apiConfig.bmServiceCreateBundle, { method: 'POST', body: JSON.stringify(postBody) }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function patchBundle(bundleId, bundleObj) {
  let postBody = {
    ...(bundleObj.name && { name: bundleObj.name }),
    ...(bundleObj.type && { type: bundleObj.type }),
    // ...(bundleObj.code && { code: bundleObj.code }),
    // ...(bundleObj.members && { members: bundleObj.members }),
    // ...(bundleObj.memberPosition && { memberPosition: bundleObj.memberPosition }),
    ...(bundleObj.description && { description: bundleObj.description }),
    ...(bundleObj.repeaterLocation && { repeaterLocation: bundleObj.repeaterLocation }),
    ...(bundleObj.address && { address: bundleObj.address }),
    ...(bundleObj.configurationParameters && { configurationParameters: bundleObj.configurationParameters })
  };

  return fetchdata(apiConfig.bmServicePatchBundle(bundleId), { method: 'PATCH', body: JSON.stringify(postBody) }).catch(
    (e) => {
      console.log('fetch data error = ' + e.message);
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
      return;
    }
  );
}

export function getConfigParams() {
  const url = apiConfig.bmServiceGetConfigParams();

  return fetchdata(url, { method: 'GET' })
    .then((result) => {
      return result.configParams || [];
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}

export function deleteBundle(bundleId) {
  return fetchdata(apiConfig.bmServiceDeleteBundle(bundleId), { method: 'DELETE' }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function getCode() {
  const url = apiConfig.bmServiceGetPodCode();

  return fetchdata(url, { method: 'GET' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
